import { ResponsiveAreaBump } from '@nivo/bump';

const bumpData = [
  {
    id: 'React',
    data: [
      { x: 2022, y: 1 },
      { x: 2023, y: 1 },
      { x: 2024, y: 2 }
    ]
  },
  {
    id: 'Vue',
    data: [
      { x: 2022, y: 3 },
      { x: 2023, y: 2 },
      { x: 2024, y: 3 }
    ]
  },
  {
    id: 'Svelte',
    data: [
      { x: 2022, y: 4 },
      { x: 2023, y: 4 },
      { x: 2024, y: 1 }
    ]
  },
  {
    id: 'Angular',
    data: [
      { x: 2022, y: 2 },
      { x: 2023, y: 3 },
      { x: 2024, y: 4 }
    ]
  }
];

export const TechRankChart = () => (
  <div style={{ height: '300px' }}>
    <ResponsiveAreaBump
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: '',
        legendPosition: 'middle',
        legendOffset: 32
      }}
      axisTop={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: '',
        legendPosition: 'middle',
        legendOffset: -36
      }}
      blendMode="multiply"
      colors={{ scheme: 'nivo' }}
      data={bumpData}
      endLabel={d => d.id}
      margin={{ top: 40, right: 100, bottom: 40, left: 100 }}
      spacing={8}
      startLabel={d => d.id}
    />
  </div>
);
